import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function exactly18CharactersValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    return String(value).length === 18 ? null : { pattern: true };
  };
}
